import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledFormStepProps extends BoxProps {
  width?: string | number;
  maxWidth?: string | number;
}

const StyledFormStep = styled(Box)<StyledFormStepProps>`
  width: ${({ width }) => width || '500px'};
  max-width: ${({ maxWidth }) => maxWidth || '500px'};
  margin: 0 auto;
  flex-grow: 1;
`;

export default StyledFormStep;
